import { defineChain } from 'viem';

//  TODO: remove and use the value on viem when available
export const oasysTestnet = defineChain({
  id: 20197,
  name: 'Oasys Testnet',
  nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.testnet.oasys.games'],
    },
  },
  blockExplorers: {
    default: {
      name: 'OasysScan',
      url: 'https://explorer.testnet.oasys.games/',
      apiUrl: 'https://explorer.testnet.oasys.games/api',
    },
  },
});

export const trexTestnet = defineChain({
  id: 1962,
  name: 'Trex Testnet',
  nativeCurrency: {
    name: 'Trex Ether',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://testnetrpc.trex.xyz'],
    },
    public: {
      http: ['https://testnetrpc.trex.xyz'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Trex Explorer',
      url: 'https://testnet.trex.xyz',
    },
  },
  testnet: true,
});
